import { Component, Input } from '@angular/core';

@Component({
    selector: 'tvcore-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    standalone: false
})
export class TooltipComponent {
	@Input()
	location: 'top' | 'right' = 'right';
}
